export default __webpack_public_path__ + "static/media/yelpThree.2cacc64f.png";